export default function isOneTrustAlertBoxClosedAndValid() {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      if (!window.OneTrust?.IsAlertBoxClosedAndValid?.()) return;
      clearInterval(interval);
      resolve();
    }, 0);
  });
}
